import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoadingPanelService } from "../../shared/loading-panel/loading-panel.service";
import { RetryOverviewService } from '../services/retry-overview.service';
import { DateTimeService } from "../../shared/datetime/datetime.service";
import { BackupFileDownloaderService } from "../../shared/download";
import { SvgIconComponent } from "../../shared/icons/svg-icon.component";
import { DxDataGridModule } from "devextreme-angular";
import { BizDataGridDirective } from "../../shared/grid/biz-grid.directive";
import { DxoEditingModule, DxoSummaryModule, DxiTotalItemModule, DxiColumnModule } from "devextreme-angular/ui/nested";
import { DxTemplateModule } from "devextreme-angular/core";

@Component({
    selector: 'app-retry-overview',
    templateUrl: './retry-overview.component.html',
    styleUrls: ['./retry-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoSummaryModule, DxiTotalItemModule, DxiColumnModule, DxTemplateModule]
})
export class RetryOverviewComponent implements OnInit {
  activeRetries: any[];

  constructor(
      private loadingPanelService: LoadingPanelService,
      private retryOverviewService: RetryOverviewService,
      public dateTimeService: DateTimeService,
      private backupFileDownloader: BackupFileDownloaderService) {
  }

  async ngOnInit() {
      this.refresh();
  }

  async refresh() {
      try {
          this.loadingPanelService.showLoadingPanelDirect('Loading active retries...');
          this.activeRetries = await this.retryOverviewService.getActiveRetries();
      }
      finally {
          this.loadingPanelService.hideLoadingPanel();
      }
  }

  async downloadFile(fileIdentifier: string, fileType: string) {
      this.loadingPanelService.showLoadingPanelDirect('Downloading file...');
      await this.backupFileDownloader.downloadFile(fileIdentifier, fileType);
      this.loadingPanelService.hideLoadingPanel();
  }

}
